<template>
  <div id="Home" class="Page Home">
    <div class="Page_wrapper">
      <img src="/assets/images/sardine.svg" alt="Sardine" />
      <transition name="title" appear>
        <h2>Le tresor du Roy Rene</h2>
      </transition>
      <transition name="content" appear>
        <p>Oyé valeureux Pirate !<br><br>
        Vous avez réussi l'abordage du navire du Roy René à la recherche de son coffre.<br>
        On ne vous a pas menti, un rutilant trésor vous attend... Voilà, un an qu'il s'aférait à réaliser les merveilleuses douceurs, le coffre est bien garni mais on ne vous avait pas tout dit. Il semblerait qu'il soit précieusement gardé. Il va falloir percer le mystère de son code à 4 chiffres pour pouvoir le savourer.<br><br><b>Sous la menace de votre sabre, le dernier matelot du navire, vous a confié le premier chiffre du code avant de sauter à l'eau, il s'agit du "un".</b></p>
      </transition>

      <transition name="cta" appear>
        <router-link :to="{ name: 'game' }"><button class="Cta">Explorer le navire</button></router-link>
      </transition>

      <img class="longuevue" src="/assets/images/longuevue.svg" alt="Longue-vue" />
      <img class="ancre" src="/assets/images/ancre.svg" alt="Ancre" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"

export default {
  components: {  },
  mixins: [ page ],
  data () {
    return {
      
    }
  },
  methods: {
    
  },
  beforeDestroy()
  {
    this.close = new Howl({
      src: ['/assets/sounds/close.mp3']
    });

    this.close.play()
  },
  created()
  {
    this.open = new Howl({
      src: ['/assets/sounds/open.mp3']
    });
  },
  mounted () {
    this.open.play()
  }
}
</script>

<style lang="stylus" scoped>

.Home

  .Page_wrapper

    max-width 860px
    position relative
    width 70%
    text-align center

    @media $large

      max-width 1024px
      width 100%

    @media $small

      width 100%
      padding-top 120px
      padding-bottom 90px

  .longuevue

    position absolute
    left 72%
    bottom 20%
    width 100px

    @media $small

      bottom 7%
      left 68%

  .ancre

    position absolute 
    left 80%
    width 120px
    bottom 13%

    @media $small

      bottom 2%
      width 80px
      left 75%

</style>
